import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, IconButton, Menu, MenuItem, Typography } from "@mui/material";

import {
  CommentIcon,
  LikeIcon,
  PostReportIcon,
  RepostIcon,
  ShareIcon,
  ShareOnGoalngo,
  ShareVia,
} from "../../assets/icons/create-feed";
import { PostActionsProps } from "../../types/components/props.type";
import { usePostLikeMutation } from "../../api/mutations/usePostLikeMutation";
import { usePostRepostMutation } from "../../api/mutations/usePostRepostMutation";
import SharePostModal from "./SharePostModal";

const buttonStyle = {
  color: "var(--Dark---1000, #111)",
  fontFamily: "Montserrat",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 500,
  lineHeight: "20px",
};

const PostActions = ({ post, handleOnClickCommentsButton }: PostActionsProps) => {
  const { t } = useTranslation("feed", { keyPrefix: "postActions" });
  const { id: postId, likesCount, commentsCount, repostsCount, isLiked, isReposted } = post;

  const { likePost, unlikePost, isLiking, isUnliking } = usePostLikeMutation({ postId });
  const { repostPost, unrepostPost, isReposting, isUnreposting } = usePostRepostMutation({ postId });

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);

  const handleLikeUnlikeClick = () => {
    if (isLiked) {
      unlikePost();
    } else {
      likePost();
    }
  };

  const handleRepostUnrepostClick = () => {
    if (isReposted) {
      unrepostPost();
    } else {
      repostPost();
    }
  };

  const handleShareOnGoalngo = () => {
    setAnchorEl(null);
    setIsShareModalOpen(true);
  };

  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "space-between", padding: "0 16px 16px" }}>
        <Button
          onClick={handleLikeUnlikeClick}
          sx={{ ...buttonStyle, color: isLiked ? "#FF4D4E" : "#111" }}
          startIcon={<LikeIcon fill={isLiked ? "#FF4D4E" : "none"} stroke={isLiked ? "#FF4D4E" : "#111"} />}
          disabled={isLiking || isUnliking}
        >
          {likesCount && likesCount}
        </Button>
        <Button
          onClick={handleRepostUnrepostClick}
          sx={{ ...buttonStyle, color: isReposted ? "#008B07" : "#111" }}
          startIcon={<RepostIcon stroke={isReposted ? "#008B07" : "#111"} />}
          disabled={isReposting || isUnreposting}
        >
          {repostsCount && repostsCount}
        </Button>
        <Button onClick={handleOnClickCommentsButton} sx={buttonStyle} startIcon={<CommentIcon />}>
          {commentsCount && commentsCount}
        </Button>
        <IconButton onClick={(event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget)}>
          <ShareIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={Boolean(anchorEl)}
          onClose={() => {
            setAnchorEl(null);
          }}
        >
          <MenuItem
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
            onClick={handleShareOnGoalngo}
          >
            <ShareOnGoalngo />
            <Typography
              sx={{
                color: "var(--Dark---1000, #111)",
                fontFamily: "Montserrat",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "20px",
              }}
            >
              {t("shareOnGoalngo")}
            </Typography>
          </MenuItem>
          {/* <MenuItem
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
            onClick={() => {}}
          >
            <ShareVia />
            <Typography
              sx={{
                color: "var(--Dark---1000, #111)",
                fontFamily: "Montserrat",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "20px",
              }}
            >
              {t("shareVia")}
            </Typography>
          </MenuItem> */}
          {/* <MenuItem
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
            onClick={() => {}}
          >
            <PostReportIcon />
            <Typography
              sx={{
                color: "var(--Dark---1000, #111)",
                fontFamily: "Montserrat",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "20px",
              }}
            >
              {t("report")}
            </Typography>
          </MenuItem> */}
        </Menu>
      </Box>
      <SharePostModal open={isShareModalOpen} onClose={() => setIsShareModalOpen(false)} postId={postId} />
    </>
  );
};

export default PostActions;
